export var ApiUrls;
(function (ApiUrls) {
    ApiUrls["AgentCreateReview"] = "/api/private/v1/surveys/create/:agentCasId";
    ApiUrls["Surveys"] = "/v1/surveys";
})(ApiUrls || (ApiUrls = {}));
